import { FAILED, LOADING, SUCCESS, ACTION, RESET, RESET_ALL } from './constants';

export const initialState = {
  dataUpdateStatus: null,
  dataUpdateStatusBulk: null,
  dataListFeatureMerchant: [],
  isLoadingUpdateStatus: false,
  isLoadingUpdateStatusBulk: false,
  isLoadingListFeatureMerchant: false,
  messageUpdateStatus: null,
  messageUpdateStatusBulk: null,
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;
  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case ACTION:
      return {
        ...state,
        action: data,
      };
    case RESET:
      return{
        ...state,
        [key]: null
      };
    case RESET_ALL:
      return initialState;
    default:
      return state;
  }
}
